/**
 * Catálogo de tipos de instrumento (símbolo + rótulo + ordem de exibição).
 * TS puro. Fonte única reusada pelo mapa (pins/legenda) e pela tabela do design
 * system (`src/ui/InstrumentTable`) — antes só existia em `M2-mapa/domain/pins`.
 */
import type { InstrumentType } from '@/domain';

export interface InstrumentTypeMeta {
  /** Símbolo do marcador/agrupador (●, ▲, ■, ◆, ✦, ♦, ◈, ◐). */
  symbol: string;
  /** Rótulo legível do tipo. */
  label: string;
  /** Unidade da leitura exibida (a leitura crua não a carrega). '' = sem unidade única. */
  unit: string;
}

export const INSTRUMENT_TYPE_META: Record<InstrumentType, InstrumentTypeMeta> = {
  PZ: { symbol: '●', label: 'Piezômetro', unit: 'kPa' },
  INA: { symbol: '▲', label: 'Indicador de NA', unit: 'm' },
  MS: { symbol: '■', label: 'Marco Superficial', unit: 'mm' },
  MSE: { symbol: '◆', label: 'Marco Expedito', unit: 'mm' },
  TILT: { symbol: '✦', label: 'Tiltímetro', unit: '°' },
  PLV: { symbol: '♦', label: 'Pluviômetro', unit: 'mm' },
  MV: { symbol: '♦', label: 'Medidor de Vazão', unit: 'L/s' },
  RL: { symbol: '♦', label: 'Régua Linimétrica', unit: 'm' },
  // EM (múltiplas grandezas) e INC (sem carta de deslocamento definida) sem unidade única.
  EM: { symbol: '◈', label: 'Estação Meteorológica', unit: '' },
  INC: { symbol: '◐', label: 'Inclinômetro', unit: '' },
};

/** Unidade de leitura de um tipo; '' quando não há unidade única ou o tipo é desconhecido. */
export function unitForType(type: string): string {
  return INSTRUMENT_TYPE_META[type as InstrumentType]?.unit ?? '';
}

/** Ordem de exibição dos tipos na tabela e na legenda. */
export const INSTRUMENT_TYPE_ORDER: InstrumentType[] = [
  'PZ', 'INA', 'MS', 'MSE', 'TILT', 'PLV', 'MV', 'RL', 'EM', 'INC',
];
